/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import { TextareaAutosize } from '@material-ui/core';

export const MessageOverride = fr.metaOverride()
  .nameOverride('content', { _component: () => TextareaAutosize });
